import HowManyInEachBox from './how-many-in-each-box';
export default HowManyInEachBox;